import { NgModule } from "@angular/core";
import { SharedModule } from "@edp-components/shared.module";
import { EdpDashboardGridModule } from "@edp-components/edp-dashboard-grid/edp-dashboard-grid.module";
import { EdpEStaticCounterModule } from "@edp-components/edp-e-static-counter/edp-e-static-counter.module";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { CampaignModalModule } from "@edp-components/campaign-modal/campaign-modal.module";
import { EdpDashboardSimpleGridModule } from "@edp-components/edp-dashboard-simple-grid/edp-dashboard-simple-grid.module";
import { ConditionalRegionModule } from "@edp-directives/conditional-region/conditional-region.module";
import { DashboardHeaderESComponent } from "./dashboard-header-es/dashboard-header-es.component";
import { DashboardESComponent } from "./dashboard-es.component";
import { DashboardRoutingESModule } from "./dashboard-routing-es.module";

@NgModule({
    imports: [
        DashboardRoutingESModule,
        SharedModule,
        EdpDashboardGridModule,
        EdpDashboardSimpleGridModule,
        // EdpEStaticCounterModule,
        SlickCarouselModule,
        // CampaignModalModule,
        ConditionalRegionModule
    ],
    declarations: [
        DashboardESComponent,
        DashboardHeaderESComponent
    ]
})
export class DashboardESModule {}
